import { Absolute } from '@rsos/base-components';
import CompassButton from './CompassButton';
import type { MapInstance as CompassMapInstance } from './CompassButton/CompassButton.types';
import ToggleButton from './ToggleButton';

interface WidgetContainerProps {
  onMeasurementClick?: () => void;
  onSketchClick: () => void;
  isMeasurementActive?: boolean;
  isSketchActive: boolean;
  mapInstance: CompassMapInstance | undefined;
  onTrackCompass?: (params: { action: string }) => void;
}

const WidgetContainer = ({
  onSketchClick,
  isSketchActive,
  mapInstance,
  onTrackCompass,
}: WidgetContainerProps) => {
  return (
    <Absolute bottom="100px" right="16px" zIndex="1" id="widget-container">
      <CompassButton
        mapInstance={mapInstance}
        onTrackCompass={onTrackCompass}
      />
      <ToggleButton onClick={onSketchClick} isActive={isSketchActive} />
      {/* addtional tools go here */}
    </Absolute>
  );
};

export default WidgetContainer;
